import { DashboardTileType, IDashboardTileComponentProps } from "@components/dashboard";
import DashboardTileHeader from "@components/dashboard/DashboardTileHeader";
import { NoData } from "@components/table/NoData";
import InfoTile from "@components/tiles/infoTile";
import {
    GroupedInfoTileBackground,
    GroupedInfoTileContentWrapper,
    GroupInfoTileHeader
} from "@components/tiles/infoTile/InfoTile.styles";
import { getEmployeeLeaveBalance, ILeaveBalanceData } from "@pages/home/EmployeeTiles";
import { isNotDefined, roundToDecimalPlaces } from "@utils/general";
import { logger } from "@utils/log";
import { getPluralFormCount } from "@utils/string";
import i18next from "i18next";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { EMPTY_DASH } from "../../constants";
import { AppContext } from "../../contexts/appContext/AppContext.types";

interface IProps extends IDashboardTileComponentProps {
}

const EmployeeLeaveBalanceTile: React.FC<IProps> = ({ inEditMode }) => {
    const [leaveBalance, setLeaveBalance] = useState<ILeaveBalanceData[]>(null);
    const { t } = useTranslation("Home");
    const context = useContext(AppContext);

    useEffect(() => {
        const fetchLeaveBalance = async () => {
            try {
                const data = await getEmployeeLeaveBalance(context);
                if (data.length > 0) {
                    setLeaveBalance(data);
                }
            } catch (e) {
                logger.error(e);
            }
        };

        fetchLeaveBalance();
    }, [context]);

    const trimmedLeaveBalance = leaveBalance?.slice(0, 4) ?? []; // Limit to 4 items

    return (
        <GroupedInfoTileBackground inEditMode={inEditMode}>
            <GroupInfoTileHeader>
                <DashboardTileHeader>{t("Home:EmployeeLeaveBalance.Heading")}</DashboardTileHeader>
            </GroupInfoTileHeader>

            {!leaveBalance?.length ? (
                <NoData isSimplified/>
            ) : (
                <GroupedInfoTileContentWrapper cols={trimmedLeaveBalance.length > 2 ? 2 : 1} rows={2} $renderAsColumns>
                    {trimmedLeaveBalance.map((item, i) => {
                        const hasHours = !!item.VacationBalanceMinutes;
                        const hours = roundToDecimalPlaces(1, item.VacationBalanceMinutes / 60);
                        const hoursLabel = hasHours ? i18next.t("Common:Time.Hours", { count: getPluralFormCount(hours)  }) : null;
                        const daysLabel = i18next.t("Common:Time.Days", { count: getPluralFormCount(item.VacationBalanceDays) });

                        return <InfoTile key={i} inEditMode={inEditMode} info={{
                            title: item.Name,
                            type: DashboardTileType.Info,
                            infoData: [{
                                value: item.VacationBalanceDays ?? EMPTY_DASH,
                                unit: isNotDefined(item.VacationBalanceDays) ? "" : daysLabel.toString(),
                                label: hasHours ? `${hours} ${hoursLabel}` : null
                            }],
                            size: { w: 2, h: 1 }
                        }} isGrouped/>;
                    })}
                </GroupedInfoTileContentWrapper>
            )}
        </GroupedInfoTileBackground>
    );
};

export default EmployeeLeaveBalanceTile;